import { motion } from 'framer-motion';
import { useGetParams } from '../../hooks/useGetParams';
import styles from './Variant.module.css';

export const Variant = ({
  item,
  index,
  isQuestionImg,
  isStateCorrectVar,
  aciveAmimate,
  delayVariant,
}) => {
  const { answerFontSize, varNumFontSize } = useGetParams();

  // анимация правильного варианта
  const titleVariants = {
    inactive: {
      color: 'rgba(0, 0, 0, 1)',
      backgroundColor: 'rgba(255, 255, 255, 1)',
      transition: { duration: 0.5 },
    },
    active: {
      color: [
        'rgba(0, 0, 0, 1)',
        'rgba(255, 255, 255, 0.2)',
        'rgba(255, 255, 255, 0.7)',
        'rgba(255, 255, 255, 0.3)',
        'rgba(255, 255, 255, 0.9)',
        'rgba(255, 255, 255, 0.5)',
        'rgba(255, 255, 255, 0.8)',
        'rgba(255, 255, 255, 0.2)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 0.7)',
        'rgba(255, 255, 255, 1)',
      ],
      backgroundColor: [
        'rgba(255, 255, 255, 1)',
        'rgba(12,250,96, 0.2)',
        'rgba(12,250,96, 0.7)',
        'rgba(12,250,96, 0.3)',
        'rgba(12,250,96, 0.9)',
        'rgba(12,250,96, 0.5)',
        'rgba(12,250,96, 0.8)',
        'rgba(12,250,96, 0.2)',
        'rgba(12,250,96, 1)',
        'rgba(12,250,96, 0.7)',
        'rgba(12,250,96, 1)',
      ],
      times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      transition: { duration: 0.7 },
    },
  };

  const numberVariants = {
    inactive: {
      color: 'rgba(0, 0, 0, 1)',
      backgroundColor: 'rgba(255, 255, 255, 1)',
      transition: { duration: 0.5 },
    },
    active: {
      color: [
        'rgba(0, 0, 0, 1)',
        'rgba(255, 255, 255, 0.2)',
        'rgba(255, 255, 255, 0.7)',
        'rgba(255, 255, 255, 0.3)',
        'rgba(255, 255, 255, 0.9)',
        'rgba(255, 255, 255, 0.5)',
        'rgba(255, 255, 255, 0.8)',
        'rgba(255, 255, 255, 0.2)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 0.7)',
        'rgba(255, 255, 255, 1)',
      ],
      backgroundColor: [
        'rgba(255, 255, 255, 1)',
        'rgba(12,250,96, 0.2)',
        'rgba(12,250,96, 0.7)',
        'rgba(12,250,96, 0.3)',
        'rgba(12,250,96, 0.9)',
        'rgba(12,250,96, 0.5)',
        'rgba(12,250,96, 0.8)',
        'rgba(12,250,96, 0.2)',
        'rgba(12,250,96, 1)',
        'rgba(12,250,96, 0.7)',
        'rgba(12,250,96, 1)',
      ],
      times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      transition: { duration: 0.7 },
    },
  };

  return (
    <motion.div
      initial={{ y: '100vw' }}
      animate={{ y: 0 }}
      transition={{ duration: 1, ease: 'easeOut', delay: delayVariant }}
      className={styles.variant}
    >
      <motion.div
        className={styles.varNumber}
        style={{
          fontSize: `${varNumFontSize}rem`,
          height: `${1.9 * varNumFontSize}rem`,
          minWidth: `${1.9 * varNumFontSize}rem`,
        }}
        variants={numberVariants}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
      >
        {index + 1}
      </motion.div>

      <motion.div
        className={styles.varTitle}
        style={{
          fontSize: `${answerFontSize}rem`,
          width: isQuestionImg ? 'auto' : '55.3125rem',
        }}
        variants={titleVariants}
        initial="inactive"
        animate={aciveAmimate ? 'active' : 'inactive'}
      >
        {item.comment}
      </motion.div>
    </motion.div>
  );
};
